import React from 'react';
import styled from '@emotion/styled';

import Container from 'components/Container';
import Hero from './sections/Hero';
import Trend from './sections/Trend';
import News from './sections/News';
import VideoBar from './sections/VideoBar';
import Hot from './sections/Hot';
// import Toolbox from './sections/Toolbox';
// import Articles from './sections/Articles';
import Advertisement from './sections/Advertisement';
import AICollege from './sections/AICollege';
// import Sidebar from './Sidebar/Sidebar';
import SocialMedia from 'components/SocialMedia';
import ScrollToTopButton from 'components/ScrollToTopButton';

import vw from 'styles/utils';
import media from 'styles/media';

function Home() {
  return (
    <Root>
      <StyledContainer>
        <FullCol>
          <Hero />
          <Trend />
          <News />
          {/* <Toolbox /> */}
          <VideoBar />
          <Hot />
          {/* <Articles /> */}
          <Advertisement />
          <AICollege />
        </FullCol>
        {/* <RightCol>
          <Sidebar />
        </RightCol> */}
      </StyledContainer>
      <SocialMedia />
      <ScrollToTopButton />
    </Root>
  )
}

const Root = styled.main`
  section {
    ${vw('padding-bottom', 30, 30, 60)}
  }
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  ${vw('padding-top', 30, 30, 60)}
  ${vw('padding-bottom', 20, 30, 40)}

  @media ${media.desktop} {
    flex-direction: row;
  }
`;

const FullCol = styled.div`
  width: 100%;
`;

// const LeftCol = styled.div`
//   @media ${media.desktop} {
//     width: 66%;
//   }
// `;

// const RightCol = styled.div`
//   @media ${media.desktop} {
//     width: 34%;
//   }
// `;

export default Home
